"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAppCampaignName = exports.validateCampaignNaming = exports.normalizeCampaignNaming = exports.CampaignAso = exports.CampaignPublishing = exports.CampaignSdk = exports.CampaignWebview = exports.CampaignTechnology = void 0;
var CampaignTechnology;
(function (CampaignTechnology) {
    CampaignTechnology["FLUTTER"] = "F";
    CampaignTechnology["UNITY"] = "U";
    CampaignTechnology["KOTLIN"] = "K";
})(CampaignTechnology = exports.CampaignTechnology || (exports.CampaignTechnology = {}));
var CampaignWebview;
(function (CampaignWebview) {
    CampaignWebview["NONE"] = "NO_W";
    CampaignWebview["REFLECTION"] = "REF";
    CampaignWebview["DEX"] = "DEX";
    CampaignWebview["REVERSE"] = "REV";
    CampaignWebview["R8"] = "R8";
})(CampaignWebview = exports.CampaignWebview || (exports.CampaignWebview = {}));
var CampaignSdk;
(function (CampaignSdk) {
    CampaignSdk["APPS"] = "Apps";
    CampaignSdk["PUSH"] = "Push";
})(CampaignSdk = exports.CampaignSdk || (exports.CampaignSdk = {}));
var CampaignPublishing;
(function (CampaignPublishing) {
    CampaignPublishing["EARLY"] = "Early";
    CampaignPublishing["NORMAL"] = "Normal";
})(CampaignPublishing = exports.CampaignPublishing || (exports.CampaignPublishing = {}));
var CampaignAso;
(function (CampaignAso) {
    CampaignAso["DIRECT_KEY"] = "DK";
    CampaignAso["SHORT_KEY"] = "SK";
    CampaignAso["WHITE_ICON"] = "WI";
})(CampaignAso = exports.CampaignAso || (exports.CampaignAso = {}));
const TECHNOLOGY_VALUES = new Set(Object.values(CampaignTechnology));
const WEBVIEW_VALUES = new Set(Object.values(CampaignWebview));
const SDK_VALUES = new Set(Object.values(CampaignSdk));
const PUBLISHING_VALUES = new Set(Object.values(CampaignPublishing));
const ASO_VALUES = new Set(Object.values(CampaignAso));
const SDK_ORDER = Object.values(CampaignSdk);
const ASO_ORDER = Object.values(CampaignAso);
function uniqueAllowedValues(values, allowed, order) {
    if (!Array.isArray(values))
        return [];
    const selected = new Set(values.filter((value) => typeof value === 'string' && allowed.has(value)));
    return order.filter((value) => selected.has(value));
}
function normalizeCampaignNaming(value) {
    const source = value && typeof value === 'object' ? value : {};
    const note = typeof source.note === 'string' ? source.note.trim().replace(/\s+/g, ' ').slice(0, 80) : '';
    return {
        technology: typeof source.technology === 'string' && TECHNOLOGY_VALUES.has(source.technology) ? source.technology : undefined,
        webview: typeof source.webview === 'string' && WEBVIEW_VALUES.has(source.webview) ? source.webview : undefined,
        sdk: uniqueAllowedValues(source.sdk, SDK_VALUES, SDK_ORDER),
        publishing: typeof source.publishing === 'string' && PUBLISHING_VALUES.has(source.publishing) ? source.publishing : undefined,
        aso: uniqueAllowedValues(source.aso, ASO_VALUES, ASO_ORDER),
        note: note || undefined,
    };
}
exports.normalizeCampaignNaming = normalizeCampaignNaming;
function validateCampaignNaming(value) {
    const naming = normalizeCampaignNaming(value);
    const missing = [];
    if (!naming.technology)
        missing.push('technology');
    if (!naming.webview)
        missing.push('webview');
    if (!naming.sdk?.length)
        missing.push('sdk');
    if (!naming.publishing)
        missing.push('publishing');
    if (!naming.aso?.length)
        missing.push('aso');
    return { valid: true, missing };
}
exports.validateCampaignNaming = validateCampaignNaming;
function normalizeNamePart(value, fallback) {
    const normalized = String(value ?? '').trim()
        .replace(/^(?:\[\d+\]|#\d+)\s*/, '')
        .replace(/\s+/g, ' ')
        .replace(/\[/g, '(')
        .replace(/\]/g, ')')
        .trim();
    return normalized || fallback;
}
function buildAppCampaignName(app) {
    const brand = normalizeNamePart(app.name, `App ${app.id}`);
    const bundle = normalizeNamePart(app.bundle, 'no-bundle');
    return `#${app.id} ${brand} [${bundle}]`;
}
exports.buildAppCampaignName = buildAppCampaignName;
